/** Desk's "Name <email>" as "Name · email" (either part alone when the other is missing). */
export function contactLabel(contact: string): string {
  const m = contact.trim().match(/^(.*?)\s*<([^>]+)>$/)
  return m ? [m[1]?.trim().replace(/^"|"$/g, ''), m[2]?.trim()].filter(Boolean).join(' · ') : contact.trim()
}
